import { render, staticRenderFns } from "./currencySettingsDetail.vue?vue&type=template&id=b2020392&scoped=true"
import script from "./currencySettingsDetail.vue?vue&type=script&lang=js"
export * from "./currencySettingsDetail.vue?vue&type=script&lang=js"
import style0 from "./currencySettingsDetail.vue?vue&type=style&index=0&id=b2020392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2020392",
  null
  
)

export default component.exports